<template>
  <b-modal
    id="tao-can-bo-truc-thuoc"
    size="xl"
    centered
    title="Chọn cán bộ"
    ref="tao-can-bo"
  >
    <validation-observer ref="obCanBo">
      <b-form>
        <p class="font-weight-bold mb-1">Danh sách cán bộ</p>
        <DataTable
          :value="danhSachCanBoTrucThuoc"
          :loading="isLoadingTable"
          dataKey="id"
          class="p-datatable-customers"
          :selection.sync="selectedCanBo"
        >
          <Column
            field="id"
            dataKey="id"
            headerStyle="width: 40px"
            headerClass="p-2"
            header=""
            bodyStyle="text-align: center"
            selectionMode="multiple"
          >
          </Column>
          <Column
            filterMatchMode="custom"
            field="hoTen"
            header="Họ tên"
            headerStyle="minWidth: 200px"
          >
            <template #body="slotProps">
              <span>{{ slotProps.data.hoTen }}</span>
            </template>
            <template #filter>
              <InputText
                type="text"
                class="p-column-filter"
                placeholder="Tìm kiếm"
                v-model="requestForm.HoTenFilter"
                @change="layDanhSachCanBo"
              />
            </template>
          </Column>
          <Column
            filterMatchMode="custom"
            field="hoTen"
            header="Mã cán bộ"
            headerStyle="minWidth: 150px"
          >
            <template #body="slotProps">
              <span>{{ slotProps.data.maCanBo }}</span>
            </template>
            <template #filter>
              <InputText
                type="text"
                class="p-column-filter"
                placeholder="Tìm kiếm"
                v-model="requestForm.MaCanBoFilter"
                @change="layDanhSachCanBo"
              />
            </template>
          </Column>
          <Column
            filterMatchMode="custom"
            field="phone_DiDong"
            header="SĐT"
            headerStyle="width: 120px"
          >
            <template #body="slotProps">
              <div class="text-center">
                <span>{{ slotProps.data.phone_DiDong }}</span>
              </div>
            </template>
            <template #filter>
              <InputText
                type="text"
                class="p-column-filter"
                placeholder="Tìm kiếm"
                v-model="requestForm.SdtFilter"
                @change="layDanhSachCanBo"
              />
            </template>
          </Column>
          <Column
            filterMatchMode="custom"
            field="ngaySinh"
            header="Ngày sinh"
            headerStyle="width: 150px"
          >
            <template #body="slotProps">
              <div class="text-center">
                <span>{{ formatDateTime(slotProps.data.ngaySinh) }}</span>
              </div>
            </template>
            <template #filter>
              <date-picker
                format="DD/MM/YYYY"
                class="d-block w-100 custom-input"
                placeholder="Chọn ngày"
                v-model="NgaySinhFilter"
                range
                @change="layDanhSachCanBo"
              ></date-picker>
            </template>
          </Column>
          <Column
            filterMatchMode="custom"
            field="email"
            header="Email"
            headerStyle="minWidth: 150px"
          >
            <template #body="slotProps">
              <span>{{ slotProps.data.email }}</span>
            </template>
            <template #filter>
              <InputText
                type="text"
                class="p-column-filter"
                placeholder="Tìm kiếm"
                v-model="requestForm.EmailFilter"
                @change="layDanhSachCanBo"
              />
            </template>
          </Column>
          <Column
            filterMatchMode="custom"
            field="diaChi"
            header="Địa chỉ"
            headerStyle="minWidth: 150px"
          >
            <template #body="slotProps">
              <span>{{ slotProps.data.diaChi }}</span>
            </template>
            <template #filter>
              <InputText
                type="text"
                class="p-column-filter"
                placeholder="Tìm kiếm"
                v-model="requestForm.DiaChiFilter"
                @change="layDanhSachCanBo"
              />
            </template>
          </Column>
          <template #empty
            ><div class="text-center">Không có dữ liệu</div></template
          >
          <template #loading
            ><div class="text-center">Đang tải dữ liệu ...</div>
          </template>
        </DataTable>
        <BasePagination
          class="mt-3"
          :total-pages="totalPages"
          :total-rows="totalRows"
          :current-page="filterForm.index"
          :is-loading="isLoadingTable"
          @changePages="onChangePages($event)"
          @changeNum="onChangeNum($event)"
        />
      </b-form>
    </validation-observer>
    <template v-slot:modal-footer>
      <div class="d-flex flex-end">
        <base-button
          class="btn btn-green"
          :disabled="isLoading"
          @click="themCanBo()"
          button="Xác nhận"
        ></base-button>
        <base-button
          class="btn btn-yellow ml-2"
          @click="dongModal"
          button="Đóng"
        ></base-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { DANH_SACH_CAN_BO } from "@/constants/constants";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import BasePagination from "@/components/common/BasePagination";
import moment from "moment";
import _cloneDeep from "lodash/cloneDeep";
const defaultForm = {
  index: 1,
  pageSize: 10,
  iDChucVu: null,
  keySearch: "",
};
const defaultRequestForm = {
  HoTenFilter: "",
  ChucVuFilter: "",
  SdtFilter: "",
  NgaySinhStartFilter: null,
  NgaySinhEndFilter: null,
  EmailFilter: "",
  DiaChiFilter: "",
};
export default {
  name: "TaoCanBoTrucThuocModal",
  components: {
    BasePagination,
  },
  data() {
    return {
      NgaySinhFilter: [],
      selectedCanBo: [],
      value: null,
      isLoadingTable: false,
      isLoading: false,
      selectAllRowsInPage: false,
      fieldNames: DANH_SACH_CAN_BO,
      totalPages: 0,
      totalRows: 0,
      filterForm: _cloneDeep(defaultForm),
      requestForm: _cloneDeep(defaultRequestForm),
    };
  },
  props: {
    valueDonVi: {
      type: Object,
      required: true,
    },
  },
  watch: {
    danhSachCanBo: {
      handler() {
        if (this.danhSachCanBo) {
          this.totalPages = this.danhSachCanBo.totalPage;
          this.totalRows = this.danhSachCanBo.totalCount;
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      danhSachCanBo: "donVi/danhSachCanBo",
      danhSachChucVu: "chucVu/danhSachChucVu",
    }),
    danhSachCanBoTrucThuoc() {
      if (!this.danhSachCanBo) {
        return [];
      }
      let danhSach = [];
      danhSach = (this.danhSachCanBo.items || []).map((item) => {
        return {
          ...item,
          checkBox: false,
        };
      });
      return danhSach;
    },
    danhSachIdCanBoTrucThuoc() {
      if (!this.danhSachCanBo) {
        return [];
      }
      let danhSach = [];
      danhSach = (this.danhSachCanBo.items || []).map((item) => item.id);
      return danhSach;
    },
  },
  created() {
    this.layDanhSachChucVu();
  },
  methods: {
    showModal() {
      this.layDanhSachCanBo();
      this.filterForm = _cloneDeep(defaultForm);
      this.$refs["tao-can-bo"].show();
    },
    layDanhSachChucVu() {
      this.$store.dispatch("chucVu/layDanhSachChucVu");
    },
    formatDateTime(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    themCanBo() {
      this.isLoading = true
      let payload = {
        donViId: this.valueDonVi.id || null,
        lstCanBo: this.selectedCanBo.map((x) => {
          return { CanBoId: x.id, IsDefault: true };
        }),
      };
      const $vm = this;
      this.$store
        .dispatch("donVi/taoMoiCanBoTrucThuoc", payload)
        .then((res) => {
          if (res.data.succeeded) {
            this.$toasted.clear();
            $vm.$toasted.global.showSuccessMessage({
              message: "Thêm thành công cán bộ",
            });
            $vm.$bvModal.hide(`tao-can-bo-truc-thuoc`);
            $vm.$emit("layDanhSachCanBo");
            $vm.selectedCanBo = [];
          } else {
            this.$toasted.clear();
            $vm.isLoading = false
            $vm.$toasted.global.showErrorMessage({
              message: res.data.message,
            });
          }
        })
        .catch(() => {
          $vm.$toasted.global.showSuccessMessage({
            message: "Lưu không thành công",
          });
        });
    },
    onChangeNum(pageSize) {
      this.selectedItem = [];
      this.filterForm.index = 1;
      this.filterForm.pageSize = pageSize;
      this.layDanhSachCanBo();
    },
    onChangePages(page) {
      this.filterForm.index = page;
      this.layDanhSachCanBo();
    },
    layDanhSachCanBo() {
      if (this.NgaySinhFilter && this.NgaySinhFilter.length) {
        this.requestForm.NgaySinhStartFilter =
          moment(this.NgaySinhFilter[0])?.format("MM/DD/YYYY") || null;
        this.requestForm.NgaySinhEndFilter =
          moment(this.NgaySinhFilter[1])?.format("MM/DD/YYYY") || null;
      } else {
        this.requestForm.NgaySinhStartFilter = null;
        this.requestForm.NgaySinhEndFilter = null;
      }
      let payload = {
        ID_DonVi: this.idDonVi || null,
        IsGetAll: false,
        PageIndex: this.filterForm.index,
        PageSize: this.filterForm.pageSize,
        FilterBy: this.filterForm.keySearch,
        ...this.requestForm,
      };
      this.isLoadingTable = true;
      this.$store.dispatch("donVi/layDanhSachCanBo", payload).then(() => {
        this.isLoadingTable = false;
      });
    },
    dongModal() {
      this.$bvModal.hide(`tao-can-bo-truc-thuoc`);
    },
  },
};
</script>
<style lang="scss">
#tao-can-bo-truc-thuoc {
  .mx-datepicker {
    width: 100% !important;
    .mx-input {
      border-radius: 0 !important;
      border: none !important;
      &:focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem #bbdefb;
      }
    }
  }
}
</style>